export const CLIENT_DISPUTES_API = '/api/internal/dispute/by-client'

// Тот же размер страницы, что в журнале мэтчинга: контракт пагинации у эндпоинтов общий.
export const PAGE_SIZE = 50
